import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import English from './langData/English.json';
import Marathi from './langData/Marathi.json';

let language = localStorage.getItem("language");
let l = 'en';
if (language) {
    l = language
}

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: English,
            },
            mr: {
                translation: Marathi,
            },
        },
        lng: l,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
